"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserVideoComponentParameters = void 0;
exports.UserVideoComponentParameters = [
    {
        id: 'prompt',
        label: 'Prompt',
        description: 'Input Param - String to be displayed on the recorder screen',
        type: 'string',
        paramType: 'STRING',
        required: false,
    },
    {
        id: 'localePrompt',
        label: 'Locale Prompt',
        description: 'Input Param - String to be displayed on the recorder screen in locale',
        type: 'string',
        paramType: 'STRING',
        required: false,
    },
    {
        id: 'minRecordingLength',
        label: 'Minimum Length',
        description: 'Input Param - Minimum length of recording',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'maxRecordingLength',
        label: 'Maximum Length',
        description: 'Input Param - Maximum length of recording',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'video',
        label: 'Video',
        description: 'Output Param - Video captured by the user',
        type: 'output',
        paramType: 'FILE',
        required: true,
    },
    {
        id: 'duration',
        label: 'Duration',
        description: 'Output Param - Duration of the video',
        type: 'output',
        paramType: 'INT',
        required: false,
    },
];
//# sourceMappingURL=UserVideoComponent.js.map